export default {"src":"/_next/static/image/public/images/ic_product_default.7dc7eb648adeb1000d7fbf5e26ddd37f.svg","height":153,"width":181};